<template>
    <div class="condition-content">
        <org-select-pop
            :single="false"
            :depart-can-select="true"
            :selected="selectedList"
            :cust-fetch-tree="getTree"
            :cust-fetch-search="searchTree"
            :with-checkbox="true"
            :only-folder-id="false"
            :use-org-item="false"
            :show-additional-footer="true"
            mode="pop"
            title-selected="已选分组"
            subtitle="选择分组"
            search-placeholder="搜索分组"
            @confirm="onSelectConfirm"
        >
            <div
                slot="trigger"
                :class="{ 'is-placeholder': !hasValue }"
                class="rule-org-select-trigger"
            >
                {{ hasValue ? showTxt : '请选择' }}<v-icon name="arrow_dropdown" />
            </div>
        </org-select-pop>
    </div>
</template>

<script>
import OrgSelectPop from '@/components/org-select';
import { getTree, searchTree } from '@/cgi/getCategoryTree';

export default {
  name: 'BusinessSelect',

  components: {
    OrgSelectPop,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    const currentValue = this.value || [];

    return {
      currentValue,
      selectedList: this.transToFormat(currentValue),
      valid: true,
      getTree,
      searchTree,
    };
  },
  computed: {
    brief() {
      return `${this.optionInfo.text}为${this.showTxt}`;
    },

    hasValue() {
      return this.currentValue && this.currentValue.length > 0;
    },

    showTxt() {
      const showArr = [];
      const groupArr = [];

      this.selectedList.forEach((item) => {
        groupArr.push(item);
      });

      if (groupArr.length > 0) {
        if (groupArr.length > 1) {
          showArr.push(`${groupArr[0].name}等${groupArr.length}个分组`);
        } else {
          showArr.push(groupArr[0].name);
        }
      }

      return showArr.join('/');
    },
  },

  watch: {
    value(newValue) {
      this.currentValue = newValue || [];
      this.selectedList = this.transToFormat(this.currentValue);
    },
  },

  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    getValidate() {
      return !!(this.currentValue.length && this.currentValue.length > 0);
    },
    validate() {
      this.valid = this.getValidate();
      return this.valid;
    },
    onChange(value) {
      this.valid = true;
      this.currentValue = value;
      const ruleData = {
        operation: 'arrayInclude',
        name: this.optionInfo.value,
        type: 'array',
        value: JSON.stringify(value),
      };

      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: this.getValidate(),
      });
    },

    onSelectConfirm(list) {
      this.onChange(list);
    },

    transToFormat(arr) {
      return arr.map((item) => {
        const { id, name } = item || {};

        return {
          id,
          name,
        };
      });
    },
  },
};
</script>

<style scoped lang="less">
.rule-org-select-trigger {
    display: inline-block;
    line-height: 30px;
    font-size: 14px;
    cursor: pointer;

    &.is-placeholder {
        color: #a8abb3;
    }

    .v-icon {
        color: #a8abb3;
        margin-left: 5px;
        width: 10px;
        height: 10px;
    }
}
</style>
